import { __awaiter } from '../_virtual/_tslib.js';
import { toast } from '../components/toast/toast.js';
import '../constants/authorizedUsers.js';
import '../constants/bidStatus.js';
import '../constants/bulkLoadCardStatus.js';
import '../constants/misc.js';
import '../constants/event-names.js';
import '../constants/eventsMapObj.js';
import '../constants/Faq.js';
import '../constants/languages.js';
import '../constants/loadStatus.js';
import '../constants/lorryStatus.js';
import '../constants/lorryTypes.js';
import '../constants/mostSearchedLinks.js';
import '../constants/Pages.js';
import 'react';
import '../constants/serviceTypeId.js';
import '../constants/StateList.js';
import '../constants/bidUpdateType.js';
import '../constants/userAction.js';
import '../constants/api.js';
import '../constants/link.js';
import '../constants/market.js';
import '../constants/payment.js';
import '../constants/admin/screenId.js';
import API from './const.js';
import 'bowser';
import './auth.service.js';
import '../methods/getAuthIdParam.js';
import 'react-cookie';
import '../methods/formatDate.js';
import '../methods/getTransporterFigure.js';
import '../methods/getDownloadsFigure.js';
import 'lodash.isequal';
import '../methods/getPageLoadSourceUTMParam.js';
import { generateQueryString } from '../methods/generateQueryString.js';
import 'crypto-js';
import { getAuthHeader } from './utils/getAuthHeader.js';

const PLACE_SEARCH_QUERY_LENGTH = 4;
function getPlacesApiFetchHeaders(option) {
    var _a;
    const headers = Object.assign({}, getAuthHeader());
    // SSR (getServerSideProps, etc.) — no CORS; backend may expect these headers.
    // Browser fetch must omit User-Agent/Origin/Referer — Safari preflights them.
    if (typeof window === "undefined") {
        const origin = (_a = option.origin) !== null && _a !== void 0 ? _a : "http://localhost:3000";
        headers.origin = origin;
        headers.referer = `${origin}/`;
        headers["user-agent"] = API.VERCEL_USER_AGENT;
    }
    return headers;
}
function searchUsingPlacesAPI(query, option) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        const { source, allowState: is_state_allowed, tag } = option !== null && option !== void 0 ? option : {};
        try {
            if (!query || query.length < PLACE_SEARCH_QUERY_LENGTH) {
                return [];
            }
            const queryParams = "&" +
                generateQueryString({
                    tag,
                    source,
                    is_state_allowed,
                    session_token: option === null || option === void 0 ? void 0 : option.searchSessionToken
                });
            const call = yield fetch(encodeURI(API.PLACES_API_SEARCH + query + queryParams), {
                headers: getPlacesApiFetchHeaders(option)
            });
            if (call.status === 200) {
                return (_b = (_a = (yield call.json())) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : [];
            }
            else {
                const errorBody = yield call.json().catch(() => ({}));
                throw new Error((errorBody === null || errorBody === void 0 ? void 0 : errorBody.message) || call.statusText || "Places search failed");
            }
        }
        catch (e) {
            if (!(option === null || option === void 0 ? void 0 : option.suppressErrorToast)) {
                toast.error("An error occured, please try again after sometime");
            }
            return [];
        }
    });
}
function getPlaceIdForStringQuery(...args) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        const [query] = args;
        if (query) {
            return (_b = (_a = (yield searchUsingPlacesAPI(...args))) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.place_id;
        }
        return undefined;
    });
}
var LocationSearchSource;
(function (LocationSearchSource) {
    LocationSearchSource["LoadSourcePosting"] = "load_source_posting";
    LocationSearchSource["LoadDestinationPosting"] = "load_destination_posting";
    LocationSearchSource["LoadWaypointPosting"] = "load_waypoint_posting";
    LocationSearchSource["LorryPostingSrc"] = "lorry_posting_src";
    LocationSearchSource["LorryPostingDest"] = "lorry_posting_dest";
    LocationSearchSource["LoadMarketPlaceSearchSource"] = "load_marketplace_search_source";
    LocationSearchSource["LoadMarketPlaceSearchDestination"] = "load_marketplace_search_destination";
    LocationSearchSource["LorryMarketPlaceSearchSource"] = "lorry_marketplace_search_source";
    LocationSearchSource["LorryMarketPlaceSearchDestination"] = "lorry_marketplace_search_destination";
    LocationSearchSource["CompanyRegistration"] = "company_registration";
    LocationSearchSource["LoadPickUpAddress"] = "load_pickup_address";
    LocationSearchSource["LoadDropAddress"] = "load_drop_address";
    LocationSearchSource["CompanyOfficeAddress"] = "company_office_address";
    LocationSearchSource["GpsAddition"] = "gps_addition";
    LocationSearchSource["CargoPurchase"] = "cargo_purchase";
    //
    LocationSearchSource["AdminNewCsUser"] = "admin_new_cs_user";
    LocationSearchSource["BulkLoad"] = "bulk_load";
    LocationSearchSource["TransporterProfile"] = "transporter_profile";
    LocationSearchSource["CityLoadSearchSource"] = "city_load_search_source";
    LocationSearchSource["CityLoadSearchDestination"] = "city_load_search_destination";
    LocationSearchSource["CityLorrySearchSource"] = "city_lorry_search_source";
    LocationSearchSource["CityLorrySearchDestination"] = "city_lorry_search_destination";
    LocationSearchSource["CompanyCurrentLocation"] = "company_current_location";
    LocationSearchSource["CompanyAddRoute"] = "company_add_route";
    LocationSearchSource["HomepageV2LoadSourcePosting"] = "homepage_v2_load_source_posting";
    LocationSearchSource["HomepageV2LoadDestinationPosting"] = "homepage_v2_load_destination_posting";
})(LocationSearchSource || (LocationSearchSource = {}));

export { LocationSearchSource, PLACE_SEARCH_QUERY_LENGTH, getPlaceIdForStringQuery, searchUsingPlacesAPI };
//# sourceMappingURL=city-search.service.js.map
